import React from 'react'
import { useNavigate, createSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import { LOGIN_WITH_PHONE_SCHEMA } from './LoginForm.constants'
import { Formik, Form } from 'formik'
import { FormattedMessage } from 'react-intl'
import { SubmitButton } from 'components/SubmitButton'
import { TextInputField } from 'components/TextInputField'
import { parsePhoneNumber } from 'awesome-phonenumber'
import { CountrySelectField, SS_COUNTRY_DEFAULT_OPTION } from 'components/CountrySelectField'
import { dashApi } from 'services/api'
import { PersistFormikValues } from 'formik-persist-values'
import { useToast } from 'hooks'
import { ROUTES } from 'containers/Base/constants'

export const PhoneLogin = () => {
  const navigate = useNavigate()
  const { showError } = useToast()

  return (
    <Formik
      initialValues={{
        countryCode: SS_COUNTRY_DEFAULT_OPTION,
        phoneNumber: '',
        country: SS_COUNTRY_DEFAULT_OPTION
      }}
      validationSchema={LOGIN_WITH_PHONE_SCHEMA}
      onSubmit={async values => {
        const countryCode = values.countryCode?.value
        const pn = parsePhoneNumber(values.phoneNumber, { regionCode: countryCode })
        const contact = pn.number?.e164 || values.phoneNumber
        const country = values.country.value.toLowerCase()
        const payload = { contact, systemId: country }

        const response = await dashApi.sendOtpForlogin(payload)
        if (!response.ok) {
          const code = response?.data?.error?.code
          showError({ code })
          return
        }

        navigate({
          pathname: ROUTES.VERIFY_PHONE,
          search: createSearchParams({ phone: contact, country }).toString()
        })
      }}
    >
      <FormWrapper>
        <PhoneNumberWrapper>
          <CountrySelectField isLogin name='countryCode' label={<FormattedMessage id='country_code' />} />

          <TextInputField name='phoneNumber' label={<FormattedMessage id='phone_number' />} />
        </PhoneNumberWrapper>

        <CountrySelectField isLogin name='country' label={<FormattedMessage id='country' />} />

        <SubmitButton>
          <FormattedMessage id='login' />
        </SubmitButton>

        <PersistFormikValues name='login-phone-form' storage='sessionStorage' />
      </FormWrapper>
    </Formik>
  )
}

const FormWrapper = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: var(--gutter);
`

const PhoneNumberWrapper = styled.div`
  display: flex;
  gap: 16px;

  & > *:first-child {
    flex: 1;
  }

  & > *:nth-child(2) {
    flex: 2;
  }
`
